module.exports = __webpack_public_path__ + "static/media/tinywow_Oleaeuropaea1500x_colored_55476087.79b40bd6.jpg";